import Vue from "vue";

Vue.directive('datepicker', {
  bind: function (el, binding, vnode) {
    $(el).datepicker({
      dateFormat: 'yy-M-dd'
    }).on('change', function () {
      var event = document.createEvent('Event');
      event.initEvent('input', true, true);
      el.dispatchEvent(event);
    });
    //$(el).prop('placeholder', 'yyyy-MMM-dd')
  },
  update: function (el, binding, vnode) {
    if (binding.arg === 'from' || binding.arg === 'to') {
      let date;
      try {
        date = $.datepicker.parseDate("yy-M-dd", binding.value);
      } catch (error) {
        date = null;
      }

      if (binding.arg === 'from') {
        $(el).datepicker('option', 'minDate', date);
      }
      if (binding.arg === 'to') {
        $(el).datepicker('option', 'maxDate', date);
      }
    }
  }
});



// WEBPACK FOOTER //
// ./src/helpers/datepicker.js